if (!customElements.get('related-products')) {
  customElements.define('related-products', class extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.id;
      this.relatedItems = 0;
      this.wrapper = this.querySelector('[data-recently-viewed-wrapper]');
      this.recentlyViewed = this.querySelector('recently-viewed');
    }

    connectedCallback() {
      this.loadRelatedProducts();
      this.loadRecentlyViewedProducts();
    }

    loadRelatedProducts() {
      const section = this.querySelector('[data-related-section]');
      if (!section) return;

      const productId = section.getAttribute('data-product-id');
      const limit = section.getAttribute('data-limit');
      const url = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${limit}&product_id=${productId}&intent=related`;

      fetch(url)
        .then((response) => response.text())
        .then((html) => this._handleRelatedProductsResponse(html, section))
        .catch(() => this._hideSection(section));
    }

    _handleRelatedProductsResponse(html, section) {
      const container = document.createElement('div');
      container.innerHTML = (new DOMParser()).parseFromString(html, 'text/html').querySelector('[data-api-related-template]').innerHTML;

      const itemCount = container.querySelectorAll('[data-grid-item]').length;

      if (itemCount > 0) {
        section.innerHTML = container.innerHTML;
        this.relatedItems = itemCount;

        const mobileColumns = parseInt(section.style.getPropertyValue('--COLUMNS-MOBILE'));
        const firstItem = section.querySelector('[data-grid-item]');
        const grid = firstItem.parentElement;

        if (mobileColumns === 0) grid.classList.add('grid--mobile-slider');

        if (section.getAttribute('data-layout') === 'slider') {
          grid.classList.add('grid--slider');
        } else {
          grid.classList.remove('grid--slider');
        }

        if (itemCount <= 2) grid.classList.add('rs-grid--centered');
      } else {
        this._hideSection(section);
      }

      this._updateVisibility();
    }

    loadRecentlyViewedProducts() {
      this.recentlyViewed.addEventListener('theme:recently-viewed:loaded', () => {
        this._handleRecentlyViewedResponse();
      });
    }

    _handleRecentlyViewedResponse() {
      const minimum = parseInt(this.recentlyViewed.dataset.minimum) || 1;
      const items = this.recentlyViewed.querySelectorAll('.product-item');
      const gridSlider = this.recentlyViewed.querySelector('grid-slider');
      const showWithoutTabs = !this.wrapper && items.length > 0;
      const showWithTabs = this.wrapper && items.length >= minimum;

      if (showWithoutTabs || showWithTabs) {
        if (showWithTabs) this.wrapper.classList.remove('hidden');
        this.recentlyViewed.classList.remove('hidden');
        this.recentlyViewed.dispatchEvent(new CustomEvent('theme:tab:check', { bubbles: true }));
        if (gridSlider) gridSlider.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
      }

      this._updateVisibility();
    }

    _hideSection(section) {
      section.dispatchEvent(new CustomEvent('theme:tab:hide', { bubbles: true }));
    }

    _updateVisibility() {
      const noRecentlyViewed = Shopify.Products.getConfig().howManyToShow < 1;
      this.classList.toggle('hidden', noRecentlyViewed && this.relatedItems < 1);
    }
  });
}
